import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'
import GetSections from '../../Services/Queries/GetSections'
import GetPeopleDetails from '../../Services/Queries/GetPeopleDetails'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import CreatePeopleService from '../../Services/Mutations/CreatePeople'
import UpdatePeople from '../../Services/Mutations/UpdatePeople'
import CreateTemplate from '../../Services/Mutations/CreateTemplate'
import UpdateSectionPosition from '../../Services/Mutations/UpdateSectionPosition'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import TemplateList from './TemplateList'
import TemplateCollection from './TemplateCollection'
import TemplatePage from './TemplatePage'
import TemplatePeople from './TemplatePeople'
import DraggableTemplateSections from '../Templates/DraggableTemplateSections'
import ListTemplates from '../../Services/Queries/ListTemplates'
import GetSectionDataMasterDetails from '../../Services/Queries/GetSectionDataMasterDetails'
import { constant } from 'lodash-es'
// import { assertLeafType } from 'apollo-client/node_modules/apollo-cache/node_modules/graphql'
import AddSectionsToPeople from '../../Services/Mutations/AddSectionsToPeople'
class CreateEditTemplate extends Component {
  toastStyle = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  constructor(props) {
    super(props)
    this.peopleType = [
      'Actor',
      'Actress',
      'Musician',
      'Singer',
      'Director',
      'Writer',
      'DOP',
      'Producer',
      'Other Film Professionals',
      'Sports Person',
      'Ex Sports Person',
      'Public Figure',
      'Politician',
      'Minister',
      'Entrepreneur',
      'Social Influencer',
      'Govt Official',
      'Doctor',
      'Others',
    ]
    this.state = {
      newSectionDetails: [],
      sectionDetails: [],
      peopleType: 'Sports',
      selectedTab: 'Lists',
      listCollectionModalVisible: false,
      peopleName: '',
      cropImage: false,
      croppedImage: '',
      limit: 20,
      personCoverImage: '',
      cropImage1: false,
      cropImage2: false,
      personProfileCroppedImage: '',
      personCoverCroppedImage: '',
      coverStoryTitle: '',
      coverStoryCardDescription: '',
      textColorOptions: [
        { item: 'white', id: 1, value: '#ffffff' },
        { item: 'black', id: 2, value: '#000000' },
        { item: 'grey', id: 3, value: '#bdbdbd' },
      ],
      selectedTextColorOption: '#ffffff',
      imageFor: '',
      personCoverImages: [],
      personProfileImages: [],
      titleOptionsVisibility: false,
      contentPosition: '50',
      displayTitleBackground: false,
      expandedImage: null,
      expanded: true,
      files: [],

      imageFor: '',
      src: null,
      crop: {
        unit: '%',
        width: 30,

        aspect: 9 / 16,
      },
      src2: null,
      crop2: {
        unit: '%',
        width: 30,

        aspect: 1,
      },
      selectedTemplates: [],
      selectedSections: [],
      templatesModalVisible: false,
      templatesList: [],
      templatelimit: 10,
      templatenextToken: null,
      templateDetailsModal: false,
      templateName: '',
    }
  }
  handlePeopleName = (e) => {
    const name = e.target.value
    this.setState({ peopleName: name })
  }
  selectType = (e) => {
    const peopleType = e.target.value
    this.setState({ peopleType: peopleType })
  }
  getTemplates = async () => {
    const input = {
      limit: this.state.templatelimit,
      templateType: 'peopleTemplate',
    }
    console.log(input, 'inputaaa templatesss')

    const data = await ListTemplates(input)
    console.log(data, 'dataaaa templatesss')
    this.setState({
      templatesList: data.items ? data.items : [],
      nextToken: data.templatenextToken,
      endReached: data.templatenextToken != null ? false : true,
    })
  }
  openTemplateListModal = () => {
    this.getTemplates()
    this.setState({ templatesModalVisible: true })
  }
  closeTemplatesModal = () => {
    this.setState({ templatesModalVisible: false })
  }
  openTemplateDetailsModal = () => {
    this.setState({ templateDetailsModal: true })
  }
  closeTemplateDetailsModal = () => {
    this.setState({ templateDetailsModal: false })
  }
  addSectionsAndCloseModal = () => {
    const { sectionDetails, selectedSections } = this.state
    const merged = [].concat.apply([], selectedSections)
    const finalArray = []
    merged.map((item, index) => {
      const input = {
        SK: item,
        sectionLabel_Te: '',
        sectionLabel_En: '',
        sectionLabel_Hi: '',
        value: item,
      }
      const itemindex = this.state.sectionDetails.findIndex((data) => data.SK == item)
      if (itemindex == -1) {
        finalArray.push(input)
      }
    })

    if (finalArray.length > 0) {
      this.setState({
        newSectionDetails: finalArray,
        sectionDetails: [...sectionDetails, ...finalArray],
        templatesModalVisible: false,
      })
    } else {
      this.setState({
        newSectionDetails: [],
        sectionDetails: [...sectionDetails],
        templatesModalVisible: false,
      })
    }
  }
  saveTemplate = async () => {
    this.setState({ templateDetailsModal: false })
    const urlParams = window.location.href.split('?')
    let peopleValue = ''
    if (urlParams && urlParams[1]) {
      peopleValue = 'people#' + urlParams[1]
    }
    const input = {
      PK: peopleValue,
      limit: this.state.limit,
    }
    console.log(input, 'inputaaa sectionsss================')
    const data = await GetSections(input)
    let sections = []
    data &&
      data.items.map((item, index) => {
        sections.push(item.SK)
      })
    console.log(data, 'dataaaa sectionsss=====')
    const createTemplateInput = {
      templateName: this.state.templateName,
      sections: sections,
      templateType: 'peopleTemplate',
    }
    console.log(createTemplateInput, 'createTemplateInput')
    const response = await CreateTemplate(createTemplateInput)
    console.log(response, 'response================')
  }
  selectTemplate = (value) => {
    const index = this.state.selectedTemplates.findIndex((item) => item == value)
    const selectedTemplates = this.state.selectedTemplates
    const selectedSections = this.state.selectedSections
    if (index == -1) {
      this.state.templatesList.map((template, tempIndex) => {
        if (template.templateName == value && template.sections) {
          selectedSections.push(template.sections)
        }
      })
      selectedTemplates.push(value)
    } else {
      selectedTemplates.splice(index, 1)
      selectedSections.splice(index, 1)
    }
    this.setState({ selectedTemplates: selectedTemplates })
  }
  handleCreatePeople = async () => {
    //add sections to people

    const urlParams = window.location.href.split('?')
    if (this.state.newSectionDetails.length) {
      const sections = []
      this.state.newSectionDetails.map((item, index) => {
        const data = {
          sectionLabel_En: item.sectionLabel_En,
          sectionLabel_Te: item.sectionLabel_Te,
          sectionLabel_Hi: item.sectionLabel_Hi,
          value: item.SK ? item.SK : item.value,
          sectionPosition: index + 1,
        }
        sections.push(data)
      })
      const sectionsInput = {
        sections: sections,
      }
      if (urlParams && urlParams[1]) {
        sectionsInput.peopleValue = 'people#' + urlParams[1]
      }
      // const data = await AddSectionsToPeople(sectionsInput)
      // console.log(data, 'dataaaaaaaaaaaaaaaaa')
    }
    // const input = {
    //   peopleName: this.state.peopleName,
    //   peopleCoverImage: this.state.personCoverImages[0].key.substring(
    //     this.state.personCoverImages[0].key.indexOf('public')
    //   ),
    //   peopleType: this.state.peopleType,
    // }
    // if (urlParams && urlParams[1]) {
    //   input.SK = this.state.peopleDetails.SK
    //   input.PK = this.state.peopleDetails.PK
    // } else {
    //   let uniqueID = ''
    //   uniqueID = await uuidv4()
    //   input.peopleValue = uniqueID
    // }

    // console.log(input, 'inputaaaaaaaaaaa')
    // const data =
    //   urlParams && urlParams[1] ? await UpdatePeople(input) : await CreatePeopleService(input)

    // console.log(data, 'dataaaaaaaaaaaa')

    // if (urlParams && urlParams[1] ? data.statusCode == 'A253' : data.statusCode == 'A252') {
    //   urlParams && urlParams[1]
    //     ? toast.success('Peope Updated Successfully', this.toastStyle)
    //     : toast.success('Peope Created Successfully', this.toastStyle)
    //   setTimeout(() => {
    //     window.location.reload()
    //   }, 2000)
    // } else {
    //   urlParams && urlParams[1]
    //     ? toast.error('Failed to update people', this.toastStyle)
    //     : toast.success('Failed to created people', this.toastStyle)
    // }
  }

  GetDate = () => {
    return (
      new Date().getFullYear() +
      '' +
      ('0' + (new Date().getMonth() + 1)).slice(-2) +
      ('0' + new Date().getDate()).slice(-2)
    )
  }
  buttonVisibilityFunc = () => {
    const visibility =
      (this.state.peopleName != '' &&
        this.state.peopleType != '' &&
        this.state.personCoverImages.length > 0) ||
      this.state.personProfileImages.length > 0
    return visibility
  }

  uploadSelectedImage = async (imageFor, crop) => {
    const fileName =
      imageFor == 'personCoverImages'
        ? this.state.selectedCoverImage.name
        : this.state.selectedProfileImage.name
    const key = fileName + '_' + Math.floor(Date.now() / 1000) + '.png'

    const path = 'public/' + this.GetDate() + '/PeopleImages/' + key
    const params = {
      key: path,
      mimeType:
        imageFor == 'personCoverImages'
          ? this.state.selectedCoverImage.type
          : this.state.selectedProfileImage.type,
    }
    const preSignedURLObject = await getPreSignedURLForImageService(params)
    const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
    const signedURL = signedURLObject.data['url']
    try {
      const formData = new FormData()
      Object.keys(signedURLObject.data.fields).forEach((key) => {
        formData.append(key, signedURLObject.data.fields[key])
      })
      const croppedFile =
        this.state.imageFor == 'personCoverImages'
          ? this.state.personCoverCroppedImage
          : this.state.personProfileCroppedImage
      const originalFile =
        this.state.imageFor == 'personCoverImages'
          ? this.state.selectedCoverImage
          : this.state.selectedProfileImage
      // Actual file has to be appended last.
      if (crop) {
        formData.append('file', croppedFile)
      } else {
        formData.append('file', originalFile)
      }
      const response = await axios({
        method: 'post',
        url: signedURL,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      let selectedImageValue = ''
      if (this.state.imageFor == 'personCoverImages') {
        selectedImageValue = this.state.croppedImageUrl
          ? this.state.croppedImageUrl
          : this.state.src
      } else {
        selectedImageValue = this.state.croppedImageUrl2
          ? this.state.croppedImageUrl2
          : this.state.src2
      }

      if (response.status) {
        const imageObj = {
          imageValue: selectedImageValue,
          key: path,
          copyRight: false,
          copyRightText: '',
          shareImage: false,
        }
        this.uploadImages(imageFor, imageObj)
      }
    } catch (err) {
      console.warn(err, 'err')
    }
  }
  uploadImages = (imageFor, imageObj) => {
    const { personCoverImages, personProfileImages } = this.state
    if (imageFor == 'personCoverImages') {
      personCoverImages.push(imageObj)
      this.setState({ personCoverImages: personCoverImages })
    } else {
      personProfileImages.push(imageObj)
      this.setState({ personProfileImages: personProfileImages })
    }
  }

  removeSelectedImage = (imageFor) => {
    if (imageFor == 'personCoverImages') {
      this.setState({
        cropImage1: false,
        src: null,
        personCoverImages: [],
        crop: {
          unit: '%',
          width: 30,
          aspect: 9 / 16,
        },
        croppedImageUrl: '',
        selectedCoverImage: '',
      })
    } else {
      this.setState({
        cropImage2: false,
        src2: '',
        personProfileImages: [],
        crop2: {
          unit: '%',
          width: 30,
          aspect: 1,
        },
        croppedImageUrl2: '',
        selectedProfileImage: '',
      })
    }
  }
  onSelectFile = (e) => {
    this.setState({ imageFor: 'personCoverImages' })
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      reader.addEventListener('load', () => this.setState({ src: reader.result }))
      reader.readAsDataURL(e.target.files[0])
      this.setState({
        cropImage1: false,
        personCoverImages: [],
        selectedCoverImage: e.target.files[0],
        // crop: false,
        croppedImageUrl: '',
        personCoverCroppedImage: '',
      })
    }
  }
  onSelectFile2 = (e) => {
    this.setState({ imageFor: 'personProfileImages' })
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      reader.addEventListener('load', () => this.setState({ src2: reader.result }))
      reader.readAsDataURL(e.target.files[0])
      this.setState({
        cropImage2: false,

        personProfileImages: [],
        selectedProfileImage: e.target.files[0],
        // crop2: false,
        croppedImageUrl2: '',
        personProfileCroppedImage: '',
      })
    }
  }

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image
  }

  onCropComplete = (crop) => {
    this.makeClientCrop(crop)
  }

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop })
  }
  onImageLoaded2 = (image) => {
    this.imageRef2 = image
  }

  onCropComplete2 = (crop) => {
    this.makeClientCrop2(crop)
  }

  onCropChange2 = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop2: crop })
  }

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg')
      this.setState({ croppedImageUrl })
    }
  }
  async makeClientCrop2(crop) {
    if (this.imageRef2 && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(this.imageRef2, crop, 'newFile.jpeg')
      this.setState({ croppedImageUrl2: croppedImageUrl })
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas')
    const pixelRatio = window.devicePixelRatio
    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    const ctx = canvas.getContext('2d')

    canvas.width = crop.width * pixelRatio * scaleX
    canvas.height = crop.height * pixelRatio * scaleY

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
    ctx.imageSmoothingQuality = 'high'

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    )

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error('Canvas is empty')
            return
          }
          blob.name = fileName
          window.URL.revokeObjectURL(this.fileUrl)
          this.fileUrl = window.URL.createObjectURL(blob)
          if (this.state.imageFor == 'personCoverImages') {
            this.setState({ personCoverCroppedImage: blob })
          } else {
            this.setState({ personProfileCroppedImage: blob })
          }
          resolve(this.fileUrl)
        },
        'image/jpeg',
        1
      )
    })
  }
  getSectionDetails = async () => {
    const urlParams = window.location.href.split('?')
    let peopleValue = ''
    if (urlParams && urlParams[1]) {
      peopleValue = 'people#' + urlParams[1]
    }
    const input = {
      PK: peopleValue,
      limit: this.state.limit,
    }
    console.log(input, 'inputaaa sectionsss')

    const data = await GetSections(input)
    console.log(data, 'dataaaa sectionsss')

    if (data && data.items) {
      const promises = data.items.map(async (item) => {
        if (item.SK.includes('section#')) {
          const inputForMasterData = {
            PK: item.PK,
            SK: item.SK,
            type: item.GSIRecordType,
          }
          const data = await GetSectionDataMasterDetails(inputForMasterData)
          if (data && data.items) {
            item.sectionDetails = data.items.filter(Boolean)
          }
        }
        return item
      })
      const finalItems = await Promise.all(promises)
      this.setState({
        sectionDetails: finalItems,
        nextToken: data.nextToken,
        endReached: data.nextToken != null ? false : true,
      })
      this.isServiceRunning = false
    }
  }
  getNextSectionDetails = async () => {
    const urlParams = window.location.href.split('?')

    const peopleValue = urlParams && urlParams[1]
    const input = {
      PK: peopleValue,
      limit: this.state.limit,
      nextToken: this.state.nextToken,
    }

    const data = await GetSections(input)
    this.setState({
      sectionDetails: [...this.state.sectionDetails, ...data.items],
      nextToken: data.nextToken,
      endReached: data.nextToken != null ? false : true,
    })
  }

  componentDidMount = async () => {
    const urlParams = window.location.href.split('?')
    if (urlParams && urlParams[1]) {
      const input = { peopleValue: 'people#' + urlParams[1] }
      const peopleDetails = await GetPeopleDetails(input)
      this.setState({
        peopleDetails: peopleDetails,
        src: peopleDetails.personCoverImage,
        peopleCoverImage: peopleDetails.personCoverImage,
        peopleName: peopleDetails.peopleName,
        peopleType: peopleDetails.peopleType,
      })
      this.setState({ peopleId: urlParams[1] })
      this.getSectionDetails()
    }
  }
  setTab = (tabValue) => {
    this.setState({ selectedTab: tabValue })
  }
  closeListCollectionModal = () => {
    this.getSectionDetails()

    this.setState({ listCollectionModalVisible: false })
  }
  addPeople = (sections) => {
    const { sectionDetails } = this.state
    this.setState({ listCollectionModalVisible: false })
    const finalSections = sectionDetails
    finalSections.push(...sections)
    this.setState({ sectionDetails: finalSections })
  }
  updateSortedOrder = async (sortedSections) => {
    // const urlParams = window.location.href.split('?')

    // const sectionValues = []
    // // const peopleValue = urlParams && urlParams[1]
    // sortedSections.map((item, index) => {
    //   item.sectionPosition = index + 1
    //   sectionValues.push({
    //     sectionValue: item.SK,
    //     sectionPosition: index + 1,
    //   })
    // })
    // console.log(this.state.sectionDetails, 'state.sectionDetails')

    this.setState({
      sectionDetails: sortedSections,
    })
    // const input = {
    //   PK: peopleValue,
    //   sectionValues: sectionValues,
    // }
    // console.log(input, 'inputtttt')
    // const data = await UpdateSectionPosition(input)
    // console.log(data, 'dataaa')
    // // if (data.statusCode == 'A279') {
    // //   this.setState({
    // //     snackbarType: 'success',
    // //     snackbarvisible: true,
    // //     snackbarInfo: 'sectionSortedSuccessfully',
    // //   })
    // // }
  }
  removeSection = (itemTodelete) => {
    const index = this.state.sectionDetails.findIndex((section) => section.SK == itemTodelete.SK)
    const sectionDetails = this.state.sectionDetails
    sectionDetails.splice(index, 1)
    this.setState({
      sectionDetails: sectionDetails,
    })
  }
  UpdateSectionDetails = (SK, label_Hi, label_Te, label_En) => {
    const index = this.state.sectionDetails.findIndex((section) => section.SK == SK)
    const sectionDetails = this.state.sectionDetails
    sectionDetails[index].sectionLabel_Te = label_Te
    sectionDetails[index].sectionLabel_Hi = label_Hi
    sectionDetails[index].sectionLabel_En = label_En
    this.setState({
      sectionDetails: sectionDetails,
    })
  }
  handleTemplateName = (e) => {
    const name = e.target.value
    this.setState({ templateName: name })
  }
  renderTemplateDetailsModal = () => {
    const { templateDetailsModal } = this.state
    return (
      <div>
        <Modal show={templateDetailsModal} onHide={() => this.closeTemplateDetailsModal()}>
          <Modal.Body>
            <text for='text'>Template Name</text>
            <div>
              <input
                type='text'
                onChange={(value) => {
                  this.handleTemplateName(value)
                }}
                value={this.state.templateName}
                placeholder='Please Enter Template Name'
              ></input>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.state.templateName ? (
              <Button onClick={() => this.saveTemplate()}>Save Template</Button>
            ) : (
              <Button disabled>Save Template</Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
  renderListCollectionModal = () => {
    const { listCollectionModalVisible, selectedTab } = this.state
    const urlParams = window.location.href.split('?')

    return (
      <div>
        <Modal show={listCollectionModalVisible} onHide={() => this.closeListCollectionModal()}>
          <Modal.Body>
            <Tabs
              id='controlled-tab-example'
              activeKey={selectedTab}
              onSelect={(k) => this.setTab(k)}
              className='mb-3'
            >
              <Tab eventKey='Lists' title='Lists'>
                <TemplateList
                  selectedTab={this.state.selectedTab}
                  createEditTemplate={true}
                  type='people'
                  sectionPosition={
                    this.state.sectionDetails && this.state.sectionDetails.length + 1
                  }
                  closeListCollectionModal={this.closeListCollectionModal}
                />
              </Tab>
              <Tab eventKey='Collections' title='Collections'>
                <TemplateCollection
                  selectedTab={this.state.selectedTab}
                  createEditTemplate={true}
                  type='people'
                  sectionPosition={
                    this.state.sectionDetails && this.state.sectionDetails.length + 1
                  }
                  closeListCollectionModal={this.closeListCollectionModal}
                />
              </Tab>
              <Tab eventKey='Page' title='Page'>
                <TemplatePage
                  selectedTab={this.state.selectedTab}
                  createEditTemplate={true}
                  type='people'
                  sectionPosition={
                    this.state.sectionDetails && this.state.sectionDetails.length + 1
                  }
                  closeListCollectionModal={this.closeListCollectionModal}
                />
              </Tab>
              <Tab eventKey='People' title='People'>
                <TemplatePeople
                  addPeople={this.addPeople}
                  selectedTab={this.state.selectedTab}
                  createEditTemplate={true}
                  type='people'
                  sectionPosition={
                    this.state.sectionDetails && this.state.sectionDetails.length + 1
                  }
                  closeListCollectionModal={this.closeListCollectionModal}
                  pageValue={urlParams && urlParams[1]}
                />
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
  renderTemplates = () => {
    const { templatesList, templatesModalVisible, selectedTemplates, selectedSections } = this.state

    return (
      <div class=' row col-md-12'>
        <div>
          <Modal show={templatesModalVisible} onHide={() => this.closeTemplatesModal()}>
            <Modal.Header>
              <label>Templates List</label>
            </Modal.Header>
            <Modal.Body>
              {templatesList.length > 0 &&
                templatesList.map((item, index) => {
                  return (
                    <div
                      class='col-md-9'
                      style={{
                        marginBottom: '5px',
                      }}
                    >
                      <div style={{ marginRight: 10 }}>
                        <input
                          value={item.templateName}
                          type='checkbox'
                          checked={selectedTemplates.includes(item.templateName)}
                          onClick={() => {
                            this.selectTemplate(item.templateName)
                          }}
                        ></input>
                        <text for={item.templateName}>
                          {item.templateName}
                          {`(${item.sections.length})`}
                        </text>
                      </div>
                    </div>
                  )
                })}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.addSectionsAndCloseModal()}>Ok</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    )
  }
  renderGeneralPeopleOptions = () => {
    const {
      peopleType,
      personCoverImages,
      personProfileImages,
      src,
      crop,
      croppedImageUrl,
      cropImage1,
      src2,
      crop2,
      croppedImageUrl2,
      cropImage2,
    } = this.state
    return (
      <div>
        <text for='text'>People Name</text>
        <div>
          <input
            type='text'
            onChange={(value) => {
              this.handlePeopleName(value)
            }}
            value={this.state.peopleName}
            placeholder='Please Enter People Name'
          ></input>
        </div>
        {!this.state.peopleName ? (
          <text for='text' style={{ color: 'red', fontSize: 10 }}>
            People Name Cannot Be Empty
          </text>
        ) : null}
        <div>
          <text for='peopleType'>Choose People Type:</text>
          <select
            onChange={(e) => {
              this.selectType(e)
            }}
          >
            {this.peopleType.map((item, index) => {
              return (
                <option value={item} selected={peopleType == item ? true : false}>
                  {item}
                </option>
              )
            })}
          </select>
        </div>
        {/* <div>
          <text for='text'>Cover Image :</text>
          <div>
            <input type='file' accept='image/*' onChange={this.onSelectFile} />
          </div>
          {cropImage1 && src && !personCoverImages.length && (
            <ReactCrop
              src={src}
              crop={crop}
              ruleOfThirds
              onImageLoaded={this.onImageLoaded}
              onComplete={this.onCropComplete}
              onChange={this.onCropChange}
            />
          )}
          {!cropImage1 ? <img style={{ maxWidth: '100%' }} src={src} /> : null}
          {!personCoverImages.length && src && !cropImage1 && (
            <button onClick={() => this.uploadSelectedImage('personCoverImages', false)}>
              Upload Image
            </button>
          )}
          {!personCoverImages.length && src && !cropImage1 && (
            <button onClick={() => this.setState({ cropImage1: true })}>Crop Image</button>
          )}
          {croppedImageUrl && <img style={{ maxWidth: '100%' }} src={croppedImageUrl} />}
          {src ? (
            <button onClick={() => this.removeSelectedImage('personCoverImages')}>
              Remove Image
            </button>
          ) : null}

          {!personCoverImages.length && croppedImageUrl ? (
            <button onClick={() => this.uploadSelectedImage('personCoverImages', true)}>
              Upload Cropped Image
            </button>
          ) : null}
          {!personCoverImages.length ? (
            <text for='text' style={{ color: 'red', fontSize: 10 }}>
              Please Upload Image
            </text>
          ) : null}

          <text for='text'>Profile Image :</text>
          <div>
            <input type='file' accept='image/*' onChange={this.onSelectFile2} />
          </div>
          {cropImage2 && src2 && !personProfileImages.length && (
            <ReactCrop
              circularCrop={true}
              src={src2}
              crop={crop2}
              ruleOfThirds
              onImageLoaded={this.onImageLoaded2}
              onComplete={this.onCropComplete2}
              onChange={this.onCropChange2}
            />
          )}
          {!cropImage2 ? <img style={{ maxWidth: '100%' }} src={src2} /> : null}
          {!personProfileImages.length && src2 && !cropImage2 && (
            <button onClick={() => this.uploadSelectedImage('personProfileImages', false)}>
              Upload Image
            </button>
          )}
          {!personProfileImages.length && src2 && !cropImage2 && (
            <button onClick={() => this.setState({ cropImage2: true })}>Crop Image</button>
          )}
          {croppedImageUrl2 && <img style={{ maxWidth: '100%' }} src={croppedImageUrl2} />}
          {src2 ? (
            <button onClick={() => this.removeSelectedImage('personProfileImages')}>
              Remove Image
            </button>
          ) : null}

          {!personProfileImages.length && croppedImageUrl2 ? (
            <button onClick={() => this.uploadSelectedImage('personProfileImages', true)}>
              Upload Cropped Image
            </button>
          ) : null}
          {!personProfileImages.length ? (
            <text for='text' style={{ color: 'red', fontSize: 10 }}>
              Please Upload Image
            </text>
          ) : null}
        </div> */}
      </div>
    )
  }
  render() {
    const {
      peopleType,
      personCoverImages,
      personProfileImages,
      src,
      crop,
      croppedImageUrl,
      cropImage1,
      src2,
      crop2,
      croppedImageUrl2,
      cropImage2,
    } = this.state
    const urlParams = window.location.href.split('?')
    return (
      <div class=' row col-md-12'>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {this.renderGeneralPeopleOptions()}
        {this.renderTemplates()}

        <div class='row' style={{ marginBottom: '5px' }}>
          <div class='col-md-2'>
            <Button
              onClick={() => {
                this.setState({ listCollectionModalVisible: true })
              }}
              variant='primary'
              size='sm'
            >
              Add Section
            </Button>
          </div>
        </div>
        {this.state.sectionDetails.length ? (
          <DraggableTemplateSections
            sectionDetails={this.state.sectionDetails}
            createEditTemplate={true}
            removeSection={this.removeSection}
            UpdateSectionDetails={this.UpdateSectionDetails}
            updateSortedOrder={this.updateSortedOrder}
          />
        ) : null}

        {this.renderListCollectionModal()}
        {this.renderTemplateDetailsModal()}
        {/* <div class='col-md-4'>
          {this.buttonVisibilityFunc() ? (
            <Button onClick={() => this.handleCreatePeople()} variant='primary'>
              Update People
            </Button>
          ) : (
            <Button onClick={() => this.handleCreatePeople()} variant='primary'>
              Update People
            </Button>
          )}
        </div>
        <div class='col-md-4'>
          {this.buttonVisibilityFunc() ? (
            <Button onClick={() => this.handleCreatePeople()} variant='primary'>
              Create People
            </Button>
          ) : (
            <Button disabled variant='primary'>
              Create People
            </Button>
          )}
        </div> */}
      </div>
    )
  }
}
export default CreateEditTemplate
